import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import { DiMaDetailsHeaderProps } from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { renderDetailsTabWithGrid } from "../../../components/Helpers"
import { UserContext } from "../../../context/UserContext"
import { FactoryGet } from "../../../models/Factory"
import { useHashTab } from "../../../../hooks/useHashTab"
import { FactoryDetails } from "./details_tab/FactoryDetails"

export function FactoryContainer() {
  const { user, isLoadingUser } = useContext(UserContext)
  const { factoryId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [factory, setFactory] = useState<FactoryGet>()

  const returnURL = `/factory-reports#factories`

  useEffect(() => {
    if (factoryId) {
      digitalManagerApi
        .get<FactoryGet>(`/factories/${factoryId}`)
        .then((res) => {
          setFactory(res.data)
        })
        .catch((err) => {
          if (err.response.status) {
            navigate(returnURL)
          }
        })
    }
  }, [factoryId, navigate, returnURL])

  if (!factoryId) {
    return <Navigate to="/factory-reports#factories" />
  }

  if (!factory || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: factory.name,
    label: "Factory ID",
    subtitle: factory.id,
  }

  return renderDetailsTabWithGrid({
    detailsHeaderProps,
    activeTab,
    handleTabChange,
    DetailsComponent: FactoryDetails,
    detailsComponentProps: {
      factory,
      user,
      setFactory,
    },
  })
}
